import React from "react";
import { IconPlus } from "@velaro/velaro-component-lib";
import { useNavigate } from "react-router-dom";

import { PrimaryButton } from "@/components/ds";

export default function CreateChatWindowButton() {
  const navigate = useNavigate();

  return (
    <div className="flex justify-end w-full">
      <PrimaryButton
        prefixIcon={<IconPlus />}
        label="Create"
        onClick={() => navigate("/chat_window?create=true")}
      />
    </div>
  );
}
